const CURINGA = '*'
const SEPARADOR = '/'
const BARRAS_DUPLICADAS = /\/{2,}/g
const SEGMENTO_NUMERICO = /^\d+$/
const SEGMENTO_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const segmentar = (caminho) => caminho.split(SEPARADOR)

const patternValido = (patternNormalizado) => {
  if (patternNormalizado === '') return false

  return segmentar(patternNormalizado).every(
    (segmento) => !segmento.includes(CURINGA) || segmento === CURINGA
  )
}

const segmentoCasa = (segmentoPattern, segmentoRota) => {
  if (segmentoPattern === CURINGA) return segmentoRota !== ''

  return segmentoPattern === segmentoRota
}

const segmentosCasam = (segmentosRota, segmentosPattern) => {
  if (segmentosRota.length !== segmentosPattern.length) return false

  return segmentosPattern.every(
    (segmento, indice) => segmentoCasa(segmento, segmentosRota[indice])
  )
}

const pareceIdentificador = (segmento) =>
  SEGMENTO_NUMERICO.test(segmento) || SEGMENTO_UUID.test(segmento)

export const normalizarRota = (rota) => {
  if (typeof rota !== 'string' || rota.trim() === '') return ''

  const caminho = rota
    .split('?')[0]
    .split('#')[0]
    .replace(BARRAS_DUPLICADAS, SEPARADOR)

  if (caminho === SEPARADOR) return caminho
  if (caminho.endsWith(SEPARADOR)) return caminho.slice(0, -1)

  return caminho
}

export const rotaCasaPattern = (rota, pattern) => {
  const rotaNormalizada = normalizarRota(rota)
  const patternNormalizado = normalizarRota(pattern)

  if (rotaNormalizada === '' || !patternValido(patternNormalizado)) return false

  return segmentosCasam(segmentar(rotaNormalizada), segmentar(patternNormalizado))
}

export const especificidadePattern = (pattern) => {
  const patternNormalizado = normalizarRota(pattern)

  if (!patternValido(patternNormalizado)) return 0

  return segmentar(patternNormalizado).filter(
    (segmento) => segmento !== '' && segmento !== CURINGA
  ).length
}

export const sugerirPattern = (pathname) => {
  const caminho = normalizarRota(pathname)

  if (caminho === '' || caminho === SEPARADOR) return caminho

  return segmentar(caminho)
    .map((segmento) => (pareceIdentificador(segmento) ? CURINGA : segmento))
    .join(SEPARADOR)
}
